import Navbar from '@/components/feature/Navbar';
import Hero from '@/components/feature/Hero';
import CatalogSection from '@/components/feature/CatalogSection';
import AboutSection from '@/components/feature/AboutSection';
import TestimonialsSection from '@/components/feature/TestimonialsSection';
import CTASection from '@/components/feature/CTASection';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <CatalogSection />
        <AboutSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}